export default "* Tøj til at bevæge sig i\n* Et område med mulighed for alsidig bevægelse\n";